import {
  useCorporateTopRatingAgenciesContext,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopRatingAgenciesContext';
import { RATING_AGENCY_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import CorporateTable
  from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables/CorporateTables/CorporateTable';

const CorporateRatingAgencies = () => {
  const { data, loading, page, paginate } = useCorporateTopRatingAgenciesContext();

  return (
    <CorporateTable
      data={ data }
      loading={ loading }
      page={ page }
      paginate={ paginate }
      companyRole={ RATING_AGENCY_NAME }
      emptyMessageText="No rating agencies during the selected period."
    />
  );
};

export default CorporateRatingAgencies;
